import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment, a as Host } from './index.js';
import { w as waitForAnimation } from './p-rUtJRH95.js';
import { d as defineCustomElement$9 } from './p-Cd2X-6KG.js';
import { d as defineCustomElement$8 } from './p-C-AXl3sC.js';
import { d as defineCustomElement$7 } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$6 } from './p-BVCTlSQE.js';
import { d as defineCustomElement$5 } from './p-BqzjvfBR.js';
import { d as defineCustomElement$4 } from './p-DGtAEhvU.js';
import { d as defineCustomElement$3 } from './p-BqnaoLp8.js';
import { d as defineCustomElement$2 } from './p-B4Sv5V7D.js';

const persistentModalCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;bottom:0;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;left:0;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;pointer-events:none;position:fixed;position:relative;right:0;top:0;z-index:var(--jw-z-index-overlays)}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .container{align-items:center;bottom:0;display:flex;justify-content:center;left:0;min-height:100%;pointer-events:none;position:relative;right:0;top:0;z-index:var(--jw-z-index-overlays)}:host .backdrop{background-color:#000000b3;bottom:0;left:0;opacity:0;pointer-events:none;position:fixed;right:0;top:0;transition:opacity .25s ease;z-index:calc(var(--jw-z-index-overlays) - 1)}:host .backdrop.-anim-fade-in{animation:fade-in .25s linear forwards;pointer-events:all}@keyframes fade-in{0%{opacity:0}to{opacity:1}}:host .backdrop.-anim-fade-out{animation:fade-out .25s linear forwards}@keyframes fade-out{0%{opacity:1}to{opacity:0}}:host .content{pointer-events:all;z-index:calc(var(--jw-z-index-overlays) + 1)}.content{background-color:var(--jw-theme-surface-elevated-default-bg-color);border-color:var(--jw-theme-surface-border-border-color);border-radius:.375rem;border-width:1px;bottom:1rem;box-shadow:var(--jw-theme-effects-shadow-shadow-xxl-box-shadow);color:var(--jw-theme-surface-text-default-color);flex:1;padding:2rem;position:fixed;right:1rem;transform:scale(0);transition:box-shadow .2s linear .01s;width:var(--jw-container-md)}.content.-anim-open{animation:ucjdos9 .5s cubic-bezier(.25,.46,.45,.94) forwards}@keyframes ucjdos9{0%{opacity:0;transform:scale(.8)}90%{opacity:1}to{transform:scale(1)}}.content.-anim-close{animation:ucjdot7 .5s cubic-bezier(.25,.46,.45,.94) forwards}@keyframes ucjdot7{0%{opacity:1;transform:scale(1)}90%{opacity:0}to{opacity:0;transform:scale(.8)}}.content.-anim-minimize{animation:ucjdoua .5s cubic-bezier(.23,1,.32,1) forwards}@keyframes ucjdoua{0%{opacity:0;transform:translate(-8px,-8px);transform-origin:100% 0}to{opacity:1;transform:translate(0);transform-origin:50% 50%}}header h2,header h3{color:var(--jw-theme-surface-text-default-color);margin:0 auto 0 0;max-width:360px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}header h2{font-size:1.25rem;line-height:1.75rem}header h2,header h3{font-family:Open Sans;font-weight:400;letter-spacing:-.0008em}header h3{font-size:1.125rem;line-height:1.5rem}header wui-icon[name=alert-circle-filled]{color:var(--jw-theme-error-surface-color)}header wui-icon[name=alert-triangle]{color:var(--jw-theme-warning-surface-color)}header wui-icon[name=check]{color:var(--jw-theme-success-surface-color)}::slotted([slot=actions]),::slotted([slot=body]){display:flex;flex:1;margin-top:2rem}::slotted([slot=body]){flex-direction:column;max-height:var(--jw-container-sm);overflow-y:auto}:host([data-display=mini]) .content{border-radius:.375rem;padding:.75rem 1rem}";

const WuiPersistentModal$1 = /*@__PURE__*/ proxyCustomElement(class WuiPersistentModal extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.displayChanged = createEvent(this, "displayChanged", 3);
        /**
         * PersistentModal header
         */
        this.header = '';
        /**
         * Disable x close button
         */
        this.closeButtonDisabled = false;
        this.display = 'closed';
        this.contentAnimClass = '';
        this.animate = async ({ content }) => {
            const promise = waitForAnimation(this.elm.querySelector('.content'));
            if (content) {
                this.contentAnimClass = content;
            }
            await promise;
        };
    }
    /**
     * Set display state
     *
     * Possible values: `'open'`, `'mini'`, `'closed'`
     */
    async setDisplay(value) {
        if (this.display === value) {
            return;
        }
        return this._setDisplay(value);
    }
    _setDisplay(value) {
        return new Promise((resolve) => {
            window.requestAnimationFrame(() => {
                switch (value) {
                    case 'open':
                        this.animate({
                            content: '-anim-open',
                        }).then(() => {
                            this.display = 'open';
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        break;
                    case 'closed':
                        this.animate({
                            content: '-anim-close',
                        }).then(() => {
                            window.requestAnimationFrame(() => {
                                // Wait for animations to finish before resetting state
                                this.display = 'closed';
                                this.displayChanged.emit(this.display);
                                resolve();
                            });
                        });
                        break;
                    case 'mini':
                        this.animate({
                            content: '-anim-minimize',
                        }).then(() => {
                            this.display = 'mini';
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        break;
                    default:
                        resolve();
                        break;
                }
            });
        });
    }
    render() {
        const { uid, header, headerPrefix, display, closeButtonDisabled } = this;
        const headerSection = (h("header", { key: '3399ae3339a8caaa59e58bcd0348f58734436830' }, h("wui-box", { key: 'd8668c242eebe83ae89b9be96204bf01a6545dae', orientation: "horizontal", align: "center", justify: "space-between" }, h("wui-box", { key: '544eef21b93e26851e3d2760f9e0981459794b7b', gutter: "sm", orientation: "horizontal", align: "center" }, headerPrefix && (h(Fragment, { key: 'd2d1f5c740cd7c46a9efb0cacd943daf37b111fc' }, 'icon' in headerPrefix && h("wui-icon", { key: 'd9992556352dc2b5fda8ff0c9e2dd1c7f03544d4', size: "md", name: headerPrefix.icon }), 'progress' in headerPrefix && (h("wui-progress-bar", { key: '925531129e8c61167df1d57b73d10276f9b387f2', type: "circular", progressValue: typeof headerPrefix.progress === 'number' ? headerPrefix.progress : undefined, indeterminate: headerPrefix.progress === 'indeterminate' })))), this.display === 'mini' ? h("h3", null, header) : h("h2", null, header)), h("wui-layout", { key: '78712bf51c6bd7cc0408d5df935f6f10a46fa499', type: "button-group", variant: "button-group-tight" }, h("wui-button", { key: 'bf51acb20010e629e2f83642b6986a3c09207adb', type: "icon-ghost", icon: display === 'open' ? 'chevron-down' : 'chevron-up', tooltip: display === 'open' ? 'Minimize' : 'Maximize', onClick: () => this.setDisplay(display === 'open' ? 'mini' : 'open') }), h("wui-button", { key: '7df33307caec8fc6398dbd0bbc7a1cbcb67ebbe1', type: "icon-ghost", icon: "x", tooltip: "Close", disabled: closeButtonDisabled, onClick: () => this.setDisplay('closed') })))));
        return (h(Host, { key: '6d96a90d74759e39756954c6797b9860431e36df', id: uid ? `wui_persistent_modal__${uid}` : '', "data-display": display, tabIndex: -1 }, h("div", { key: '87846b76c4ab433fe51de846624f10142178bc57', class: "container" }, h("div", { key: '994414201d93fc36130fce5c6b2ee2d079eb0734', class: `content ${this.contentAnimClass}` }, display === 'mini' ? (h(Fragment, null, headerSection)) : (h(Fragment, null, headerSection, h("slot", { name: "body" }))), display !== 'mini' && h("slot", { key: '70b861e6dfb0197a9ecfb7069abe4fe6c5854557', name: "actions" })))));
    }
    get elm() { return this; }
    static get style() { return persistentModalCss; }
}, [257, "wui-persistent-modal", {
        "uid": [1],
        "api": [16],
        "header": [1],
        "headerPrefix": [16, "header-prefix"],
        "closeButtonDisabled": [4, "close-button-disabled"],
        "display": [32],
        "contentAnimClass": [32],
        "setDisplay": [64]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-persistent-modal", "wui-box", "wui-button", "wui-icon", "wui-layout", "wui-loader", "wui-progress-bar", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-persistent-modal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiPersistentModal$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-progress-bar":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiPersistentModal = WuiPersistentModal$1;
const defineCustomElement = defineCustomElement$1;

export { WuiPersistentModal, defineCustomElement };
